/*
 * This file is generated by scripts/generate-ts-colors.ts DON'T MODIFY CONTENT HERE
 */

export enum Colors {
  colorDarkest = '#24252d',
  colorLight = '#7c8498',
}
